/* eslint-disable */
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { TableSortLabel } from '@mui/material';
import _ from 'lodash';
import { visuallyHidden } from '@mui/utils';
import EditAccountManagementAdminEEntry from './AccountManagement/EditAccountManagementAdminEEntry';
import DeleteAccountManagementAdminEEntry from './AccountManagement/DeleteAccountManagementAdminEEntry';

const columns = [
  {
    id: 'id',
    label: 'ลำดับที่',
    align: 'left',
  },
  {
    id: 'username',
    label: 'ผู้ใช้',
    align: 'left',
  },
  {
    id: 'email',
    label: 'อีเมลล์',
    align: 'left',
  },
  {
    id: 'merchantname',
    label: 'ชื่อร้านค้า',
    align: 'left',
  },
  {
    id: 'role',
    label: 'หน้าที่',
    align: 'left',
  },
  {
    id: 'action',
    label: ' ',
    align: 'center',
    minWidth: 200,
  },
];

function TableManagementAdminEEntry({
  isManagementAdmin,
  pagination,
  handlePaginationChange,
  merchant,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    handlePaginationChange('handleChangePage', newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPage(newSize);
    setPage(0);
    handlePaginationChange('handleChangeRowsPerPage', newSize);
  };

  const [editAccountData, setEditAccountData] = useState(null);
  const [deleteAccountData, setDeleteAccountData] = useState(null);
  const [EditAccountManagementPopupOpen, setEditAccountManagementPopupOpen] =
    useState(false);

  const [
    DeleteAccountManagementPopupOpen,
    setDeleteAccountManagementPopupOpen,
  ] = useState(false);

  const handleOpenEditAccountManagementPopupOpen = (row) => {
    setEditAccountData(row);
    setEditAccountManagementPopupOpen(true);
  };
  const handleOpenDeleteAccountManagementPopupOpen = (row) => {
    setDeleteAccountData(row.id); // Store the ID of the row to be deleted
    setDeleteAccountManagementPopupOpen(true);
  };

  const handleCloseEditAccountManagementPopupOpen = () => {
    setEditAccountManagementPopupOpen(false);
  };
  const handleCloseDeleteAccountManagementPopupOpen = () => {
    setDeleteAccountManagementPopupOpen(false);
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: 460, overflowY: 'auto' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, color: '#fff' }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {_.size(isManagementAdmin) ? (
            <TableBody>
              {isManagementAdmin
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                    }}
                    className="hover:bg-gray-200 cursor-pointer"
                  >
                    <TableCell align="left">
                      {index + 1 ? index + 1 : '-'}
                    </TableCell>
                    <TableCell align="left">
                      {row.username ? row.username : '-'}
                    </TableCell>
                    <TableCell align="left">
                      {row.email ? row.email : '-'}
                    </TableCell>
                    <TableCell align="left">
                      {Array.isArray(row.company_name) &&
                      row.company_name.length > 0 ? (
                        <div>
                          {row.company_name.map((name, index) => (
                            <div key={index}>{name}</div>
                          ))}
                        </div>
                      ) : (
                        '-'
                      )}
                    </TableCell>
                    <TableCell align="left">
                      {row.role ? row.role : '-'}
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        sx={{
                          color: '#F4BA27',
                        }}
                        onClick={() =>
                          handleOpenEditAccountManagementPopupOpen(row)
                        }
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        sx={{
                          color: '#FC3A3A',
                        }}
                        onClick={() =>
                          handleOpenDeleteAccountManagementPopupOpen(row)
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={10} align="center">
                  <div>ไม่มีข้อมูล</div>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={pagination.total}
        rowsPerPage={pagination.size}
        page={pagination.currPage - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <EditAccountManagementAdminEEntry
        merchant={merchant}
        open={EditAccountManagementPopupOpen}
        onClose={handleCloseEditAccountManagementPopupOpen}
        data={editAccountData}
      />
      <DeleteAccountManagementAdminEEntry
        open={DeleteAccountManagementPopupOpen}
        onClose={handleCloseDeleteAccountManagementPopupOpen}
        userId={deleteAccountData}
      />
    </>
  );
}

export default TableManagementAdminEEntry;
